export default __webpack_public_path__ + "static/media/fr.71349a99.svg";